import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

import { publicRoutes } from '@app/router/publicRoutes'
import { privateRoutes } from '@app/router/privateRoutes'
import { routes as paths } from '@app/router/routes'
import { hasActiveSession } from '@core/auth/session'
// Layouts come from the active pack — swap packs in `src/app/layouts/index.ts`.
// OnboardingLayout is published by the pack too; mount it here (as its own '/'
// entry) once the onboarding module lands.
import { AppLayout, AuthLayout, SignUpLayout } from '@app/layouts'
import { authRoutes } from '@modules/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: AuthLayout,
    children: [...publicRoutes],
  },
  {
    path: '/',
    component: SignUpLayout,
    children: [...authRoutes],
  },
  {
    path: '/',
    component: AppLayout,
    children: [...privateRoutes],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  const isAuthenticated = hasActiveSession()

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)

  const requiresGuest = to.matched.some((record) => record.meta.requiresGuest)

  if (requiresAuth && !isAuthenticated) {
    return { path: paths.LOGIN }
  }

  if (requiresGuest && isAuthenticated) {
    return { path: paths.DASHBOARD }
  }

  return true
})

export default router
